import Api from "../../../../../Services/Api";
import { contructQueryParam, fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import {
  removeNullFields
} from "../../../../common/mapper";

export const mapSalesProgramOption = (item) => {
  const [day, month, year] = item.tanggalSelesai.split("-").map(Number);
  const tanggalSelesai = new Date(year, month - 1, day);
  const gracePeriod = new Date(tanggalSelesai);

  gracePeriod.setDate(gracePeriod.getDate() + item.gracePeriod);

  return {
    label: item.name,
    value: item.promoId,
    id: item.id,
    tanggalSelesai,
    gracePeriod,
  };
};

export const buildSalesProgramRequest = ({
  kodeCabang,
  promoType,
  kodeVariant,
  idWarna,
  leasingId,
  downPayment,
  tenor,
}) => {
  const creditParams =
    promoType === "CREDIT"
      ? {
          leasingId,
          downPayment,
          tenor,
        }
      : {};

  return removeNullFields({
    kodeCabang,
    promoType,
    kodeVariant,
    idWarna,
    ...creditParams,
  });
};

export const fetchSalesProgramOptions = async ({
  kodeCabang,
  promoType,
  kodeVariant,
  idWarna,
  leasingId,
  downPayment,
  tenor,
  setError,
}) => {
  const result = await fetchDataAsync({
    asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterPromoSalesOrder,
    setError,
    menuName: "Faktur Jual - Sales Order",
    args: contructQueryParam(buildSalesProgramRequest({
      kodeCabang,
      promoType,
      kodeVariant,
      idWarna,
      leasingId,
      downPayment,
      tenor,
    })),
  });

  if (
    !result.ok ||
    result.data.status !== HttpStatus.SUCCESS ||
    !Array.isArray(result.data.data)
  ) {
    return [];
  }

  return result.data.data.map(mapSalesProgramOption);
};
